import { Link, useParams } from '@tanstack/react-router';
import { useTenant } from '../api/hooks';
import { PageHeader } from '../components/page';
import { TenantTeamsSection } from './TenantTeamsSection';

export function TenantTeamsPage() {
  const { tenantId } = useParams({ from: '/tenants/$tenantId/teams' });
  const tenant = useTenant(tenantId);
  return (
    <div>
      <Link
        to="/tenants/$tenantId"
        params={{ tenantId }}
        className="mb-3 inline-flex text-sm text-muted-foreground hover:underline"
      >
        {tenant.data?.name ?? 'Tenant'}
      </Link>
      <PageHeader
        title="Teams"
        description={`Create and manage teams in ${tenant.data?.name ?? 'this tenant'}.`}
      />
      <TenantTeamsSection key={tenantId} tenantId={tenantId} />
    </div>
  );
}
